module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-Pathfinder-Modern.0053e5df.jpeg";